import React from 'react';
import imgResolver from '../utils/img-resolver';

class SettingsBilling extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editingCard: false
        };
    }

    render () {
        return (
            <div className={"settings-billing" + (this.props.isActive ? " active" : "")}>
                {this.renderCard()}

                <div className="tab-section tab-section-invoice">
                    <div className="col col-left">
                        <h3 className="invoice-title">Invoices #4345</h3>
                        <div className="invoice-info">Due date: 4. March 2015 | Download PDF</div>
                    </div>

                    <div className="col col-right">
                        <div className="invoice-total">Total: 45€</div>
                    </div>
                </div>

                <div className="tab-section tab-section-invoice">
                    <div className="col col-left">
                        <h3 className="invoice-title">Invoices #4345</h3>
                        <div className="invoice-info">Due date: 4. March 2015 | Download PDF</div>
                    </div>

                    <div className="col col-right">
                        <div className="invoice-total">Total: 45€</div>
                    </div>
                </div>

                <div className="tab-section tab-section-invoice">
                    <div className="col col-left">
                        <h3 className="invoice-title">Invoices #4345</h3>
                        <div className="invoice-info">Due date: 4. March 2015 | Download PDF</div>
                    </div>

                    <div className="col col-right">
                        <div className="invoice-total">Total: 45€</div>
                    </div>
                </div>

                <div className="tab-section tab-section-view-all">
                    <button className="btn-view-all">View all invoices</button>
                </div>
            </div>
        );
    }

    renderCard() {
        if (this.state.editingCard) {

            return (
                <div className="tab-section tab-section-card-edit">
                    <div className="cols">
                        <div className="col col-1">
                            <label className="form-control form-control-text">
                                <h3 className="label-title">Card number</h3>
                                <input type="text"/>
                                <span className="error-msg"></span>
                            </label>

                            <label className="form-control form-control-text">
                                <h3 className="label-title">Card holder name</h3>
                                <input type="text"/>
                                <span className="error-msg"></span>
                            </label>
                        </div>

                        <div className="col col-2">
                            <label className="form-control form-control-text">
                                <h3 className="label-title">Expiry date</h3>
                                <input type="text"/>
                                <span className="error-msg"></span>
                            </label>

                            <label className="form-control form-control-text form-control-csv">
                                <h3 className="label-title">CSV</h3>
                                <input type="text"/>
                                <span className="error-msg"></span>
                            </label>
                        </div>

                        <div className="col col-3">
                            <p>We need your credit card details in order to take our cut from your shifts.</p>
                            <p>Our fee is {DJ_CONST.LOCALE_CONF.currency}2.99 per shift.</p>
                            <p>You only need to enter your credit card details once, but can change them at any time.</p>
                            <p>If you do not have access to credit card, send an email</p>
                        </div>
                    </div>

                    <div className="buttons">
                        <button className="btn btn-small btn-green">Save</button>
                        <button className="btn-transparent" onClick={this.toggleEditingCard.bind(this)}>CANCEL</button>
                        <button className="btn-transparent">DELETE</button>
                    </div>
                </div>
            )
        }
        else {

            return (
                <div className="tab-section tab-section-card">
                    <div className="col col-left">
                        <h3 className="label-title">Card info</h3>
                        <div>
                            <img className="card-icon" src={require('../styles/images/icon_card.svg')} />
                            <div className="card-text">
                                <div>James Smith</div>
                                <div>**** **** **** 3545</div>
                            </div>
                        </div>
                    </div>

                    <div className="col col-right">
                        <button className="btn-change-card" onClick={this.toggleEditingCard.bind(this)}>CHANGE CARD</button>
                    </div>
                </div>
            )
        }
    }

    toggleEditingCard() {
        this.setState({
            editingCard: !this.state.editingCard
        });
    }
}

export default SettingsBilling;



/** WEBPACK FOOTER **
 ** ./app/src/components/SettingsBilling.js
 **/